export interface UserDisplayFields {
  firstName?: string;
  lastName?: string;
  email?: string;
  userId?: string;
}

export function displayName(u: UserDisplayFields): string {
  const full = [u.firstName, u.lastName].filter(Boolean).join(' ').trim();
  return full || u.email || u.userId || 'Unknown user';
}

export function initials(u: UserDisplayFields): string {
  const f = (u.firstName ?? '').trim();
  const l = (u.lastName ?? '').trim();
  if (f || l) return `${f[0] ?? ''}${l[0] ?? ''}`.toUpperCase();
  if (u.email) return u.email[0]?.toUpperCase() ?? '?';
  return '?';
}
